import React from 'react';

interface IndustryDescriptionProps {
  industryType: number;
  isPreSelected?: boolean;
}

const IndustryDescription: React.FC<IndustryDescriptionProps> = ({ industryType, isPreSelected = false }) => {
  const descriptions: Record<number, string> = {
    0: "Facilities Management - Manage building maintenance, repairs, and operations for commercial and residential properties.",
    1: "Healthcare - Streamline maintenance operations for hospitals, clinics, and healthcare facilities with compliance tracking.",
    2: "Education - Handle maintenance requests and facility management for schools, universities, and educational institutions.",
    3: "Retail - Manage store maintenance, equipment repairs, and facility operations for retail chains and shopping centers.",
    4: "Manufacturing - Oversee equipment maintenance, safety compliance, and production facility operations.",
    5: "Government - Handle public facility maintenance, infrastructure repairs, and municipal operations.",
    6: "Hospitality - Manage hotel, restaurant, and hospitality facility maintenance and guest service operations.",
    7: "Religious Organizations - Coordinate maintenance and facility management for churches, temples, and religious centers.",
    8: "Custom - Tailored solutions for specialized industries and unique business requirements.",
    9: "Property Management - Coordinate multi-unit property maintenance, tenant requests, equipment tracking, and vendor management for apartments and condos."
  };

  const selectedDescription = descriptions[industryType];
  
  if (!selectedDescription) {
    return null;
  }

  return (
    <div className={`mt-2 p-3 rounded-lg border ${
      isPreSelected 
        ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800' 
        : 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800'
    }`}>
      {isPreSelected && (
        <div className="flex items-center mb-2">
          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
          <p className="text-xs font-semibold text-green-700 dark:text-green-300 uppercase tracking-wide">
            Pre-selected for you
          </p>
        </div>
      )}
      <p className={`text-sm ${
        isPreSelected 
          ? 'text-green-700 dark:text-green-300' 
          : 'text-blue-700 dark:text-blue-300'
      }`}>
        {selectedDescription}
      </p>
    </div>
  );
};

export default IndustryDescription;
